import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, MenuItem, Select, InputLabel, FormControl, Grid, IconButton, FormControlLabel, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import axiosInstance from '../../utils/axiosConfig';
import axios from 'axios';

const Agent = () => {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [agentName, setAgentName] = useState('');
  const [agentLanguage, setAgentLanguage] = useState('');
  const [firstMessage, setFirstMessage] = useState('');
  const [twilioPhoneNumber, setTwilioPhoneNumber] = useState('');
  const [elevenlabsAgentId, setElevenlabsAgentId] = useState('');
  const [prompt, setPrompt] = useState('');
  const [variables, setVariables] = useState([]);
  const [transcriptionAnalysis, setTranscriptionAnalysis] = useState('');
  const [dataPostUrl, setDataPostUrl] = useState('');
  const [active, setActive] = useState(true);
  const [type, setType] = useState('');
  const [errorCallUrl, setErrorCallUrl] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [transcriptionAnalysisPrompt, setTranscriptionAnalysisPrompt] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [testNumber, setTestNumber] = useState('');
  const [extraData, setExtraData] = useState({});
  const [extraDataFields, setExtraDataFields] = useState([{ name: '', value: '' }]);

  // Fetch agents when component mounts
  useEffect(() => {
    fetchAgents();
    fetchPhoneNumbers();
  }, []);

  const fetchAgents = async () => {
    try {
      const response = await axiosInstance.get('/agents');
      setAgents(response.data);
    } catch (error) {
      console.error('Error fetching agents', error);
    }
  };

  const fetchPhoneNumbers = async () => {
    try {
      const response = await axiosInstance.get('/phoneNumbers');
      setPhoneNumbers(response.data);
    } catch (error) {
      console.error('Error fetching phone numbers', error);
    }
  };

  const handleCreateAgent = async () => {
    try {
      const newAgent = {
        name: agentName,
        twilio_phone_number: twilioPhoneNumber,
        elevenlabs_agent_id: elevenlabsAgentId,
        prompt: prompt,
        first_message: firstMessage,
        variables: variables,
        //transcription_analysis: transcriptionAnalysis,
        transcription_analysis_prompt: transcriptionAnalysisPrompt,
        data_post_url: dataPostUrl,
        active: active,
        type: type,
        error_call_url: errorCallUrl,
      };
      const response = await axiosInstance.post('/agents', newAgent);
      setAgents([...agents, response.data]);
      clearForm();
    } catch (error) {
      console.error('Error creating agent', error);
    }
  };

  const handleSelectAgent = (agent) => {
    setSelectedAgent(agent);
    setAgentName(agent.name);
    setTwilioPhoneNumber(agent.twilio_phone_number);
    setElevenlabsAgentId(agent.elevenlabs_agent_id);
    setPrompt(agent.prompt);
    setFirstMessage(agent.first_message);
    setVariables(agent.variables);
    setTranscriptionAnalysisPrompt(agent.transcription_analysis_prompt);
    setDataPostUrl(agent.data_post_url);
    setActive(agent.active);
    setType(agent.type);
    setErrorCallUrl(agent.error_call_url);
  };

  const handleUpdateAgent = async () => {
    try {
      const updatedAgent = {
        name: agentName,
        twilio_phone_number: twilioPhoneNumber,
        elevenlabs_agent_id: elevenlabsAgentId,
        prompt: prompt,
        first_message: firstMessage,
        variables: variables,
        transcription_analysis_prompt: transcriptionAnalysisPrompt,
        data_post_url: dataPostUrl,
        active: active,
        type: type,
        error_call_url: errorCallUrl,
      };
      const response = await axiosInstance.put(`/agents/${selectedAgent?._id}`, updatedAgent);
      setAgents(agents.map(agent => agent.id === selectedAgent.id ? response.data : agent));
      clearForm();
    } catch (error) {
      console.error('Error updating agent', error);
    }
  };

  const handleDeleteAgent = async (id) => {
    try {
      await axiosInstance.delete(`/agents/${id}`);
      setAgents(agents.filter(agent => agent.id !== id));
    } catch (error) {
      console.error('Error deleting agent', error);
    }
  };

  const clearForm = () => {
    setSelectedAgent(null);
    setAgentName('');
    setTwilioPhoneNumber('');
    setElevenlabsAgentId('');
    setPrompt('');
    setFirstMessage('');
    setVariables([]);
    //setTranscriptionAnalysis(false);
    setTranscriptionAnalysisPrompt('');
    setDataPostUrl('');
    setActive(false);
    setType('');
    setErrorCallUrl('');
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  async function makeOutboundCall() {
    try {
      const response = await axios.post("https://callserver-production.up.railway.app/outbound-call", {
        number: testNumber,
        extraData: extraData,
        agentId: selectedAgent._id
      });
      console.log("Chiamata effettuata con successo:", response.data);
    } catch (error) {
      console.error("Errore durante la chiamata:", error);
    }
  }

  const handleTest = () => {
    // Implementa la logica per il test qui
    console.log('Test number:', testNumber);
    console.log('Extra data:', extraData);
    makeOutboundCall();
    handleCloseDialog();
  };

  const handleAddField = () => {
    setExtraDataFields([...extraDataFields, { name: '', value: '' }]);
  };

  const handleFieldChange = (index, field, value) => {
    const newFields = [...extraDataFields];
    newFields[index][field] = value;
    setExtraDataFields(newFields);

    // Update extraData object
    const newExtraData = {};
    newFields.forEach(({ name, value }) => {
      if (name) newExtraData[name] = value;
    });
    setExtraData(newExtraData);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="div">
                Agent List
              </Typography>
              {agents?.map(agent => (
                <Box key={agent._id} sx={{ marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleSelectAgent(agent)}
                  >
                    {agent.name}
                  </Button>
                  <Button onClick={() => {handleOpenDialog(); setSelectedAgent(agent)}} color="primary">
                    Test
                  </Button>
                  <IconButton onClick={() => handleDeleteAgent(agent._id)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent sx={{ maxHeight: '90vh', overflowY: 'auto' }}>
              <Typography variant="h5" component="div">
                {selectedAgent ? 'Edit Agent' : 'Create Agent'}
              </Typography>
              <TextField
                label="Agent Name"
                fullWidth
                margin="normal"
                value={agentName}
                onChange={(e) => setAgentName(e.target.value)}
              />
              <FormControl fullWidth margin="normal">
                <InputLabel id="type-label">Type</InputLabel>
                <Select
                  labelId="type-label"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  label="Type"
                >
                  <MenuItem value="Web">Web</MenuItem>
                  <MenuItem value="Cell">Cell</MenuItem>
                </Select>
              </FormControl>
              {type === 'Cell' && (
                <FormControl fullWidth margin="normal">
                  <InputLabel id="twilio-phone-number-label">Twilio Phone Number</InputLabel>
                  <Select
                    labelId="twilio-phone-number-label"
                    value={twilioPhoneNumber}
                    onChange={(e) => setTwilioPhoneNumber(e.target.value)}
                    label="Twilio Phone Number"
                  >
                    {phoneNumbers.map((number) => (
                      <MenuItem key={number._id} value={number._id}>
                        {number.phoneNumber}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <TextField
                label="Elevenlabs Agent ID"
                fullWidth
                margin="normal"
                value={elevenlabsAgentId}
                onChange={(e) => setElevenlabsAgentId(e.target.value)}
              />
              <TextField
                label="Prompt"
                fullWidth
                margin="normal"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                multiline
                rows={10}
              />
              <TextField
                label="First Message"
                fullWidth
                margin="normal"
                value={firstMessage}
                onChange={(e) => setFirstMessage(e.target.value)}
              />
              <TextField
                label="Variables"
                fullWidth
                margin="normal"
                value={variables.join(', ')}
                onChange={(e) => setVariables(e.target.value.split(',').map(v => v.trim()))}
              />
              <TextField
                label="Data Post URL"
                fullWidth
                margin="normal"
                value={dataPostUrl}
                onChange={(e) => setDataPostUrl(e.target.value)}
              />
              <TextField
                label="Error Call URL"
                fullWidth
                margin="normal"
                value={errorCallUrl}
                onChange={(e) => setErrorCallUrl(e.target.value)}
              />
              <TextField
                label="Transcription Analysis Prompt"
                fullWidth
                margin="normal"
                value={transcriptionAnalysisPrompt}
                onChange={(e) => setTranscriptionAnalysisPrompt(e.target.value)}
                multiline
                rows={10}
              />
              <Button variant="contained" color="primary" onClick={selectedAgent ? handleUpdateAgent : handleCreateAgent}>
                {selectedAgent ? 'Update Agent' : 'Create Agent'}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Test Agent</DialogTitle>
        <DialogContent>
          <TextField
            label="Number"
            fullWidth
            margin="normal"
            value={testNumber}
            onChange={(e) => setTestNumber(e.target.value)}
          />
          {extraDataFields.map((field, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
              <TextField
                label="Name"
                fullWidth
                margin="normal"
                value={field.name}
                onChange={(e) => handleFieldChange(index, 'name', e.target.value)}
              />
              <TextField
                label="Value"
                fullWidth
                margin="normal"
                value={field.value}
                onChange={(e) => handleFieldChange(index, 'value', e.target.value)}
              />
            </Box>
          ))}
          <Button onClick={handleAddField} color="primary">
            Aggiungi Campo
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleTest} color="primary">
            Test
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Agent;
